module.exports = __webpack_public_path__ + "img/news_all.7b15d3a8.svg";